import React, { useEffect, useState } from 'react';
import {
    Box,
    Button,
    TextField,
    Modal,
    Typography,
} from '@mui/material';
import Nlayout from './Nlayout';
import axios from 'axios';

const API_KEY = process.env.REACT_APP_PANEL_API_KEY || process.env.REACT_APP_INTERNAL_API_KEY || 'ed_qatar_2022_messi_dengueclarasoluna_2026';
const API_HEADERS = {
    'x-internal-api-key': API_KEY,
    'x-api-key': API_KEY,
};

const modalStyle = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 350,
    bgcolor: 'background.paper',
    borderRadius: '10px',
    boxShadow: 24,
    p: 4,
};

function LimiteTipeos() {
    const [cantidad, setCantidad] = useState('');
    const [estado, setEstado] = useState(null);
    const [mensaje, setMensaje] = useState('');
    const [modalAbierto, setModalAbierto] = useState(false);
    const [accion, setAccion] = useState('set'); // 'set' | 'off'
    const [clave, setClave] = useState('');
    const [loading, setLoading] = useState(false);

    const cargarEstado = async () => {
        try {
            const res = await axios.get('https://backend.eldenguee.com/solicitudes/limite-tipeos');
            setEstado(res.data);
        } catch (err) {
            console.error('Error al obtener límite de tipeos:', err);
        }
    };

    useEffect(() => {
        cargarEstado();
    }, []);

    const abrirConfirmacion = (tipo) => {
        setAccion(tipo);
        setClave('');
        setModalAbierto(true);
    };

    const handleConfirmar = async () => {
        setLoading(true);
        setMensaje('');
        try {
            const body = accion === 'off'
                ? { activo: false, clave }
                : { cantidad: parseInt(cantidad, 10), clave };

            const res = await axios.post(
                'https://backend.eldenguee.com/solicitudes/limite-tipeos',
                body,
                { headers: API_HEADERS }
            );

            setMensaje(res.data.mensaje);
            setEstado(res.data);
            setModalAbierto(false);
            setClave('');
            if (accion === 'set') setCantidad('');
        } catch (err) {
            setMensaje(`Error: ${err.response?.data?.error || err.message}`);
            setModalAbierto(false);
        } finally {
            setLoading(false);
        }
    };

    const cantValida = cantidad !== '' && !isNaN(parseInt(cantidad, 10)) && parseInt(cantidad, 10) >= 0;

    return (
        <Nlayout>
            <Box p={4}>
                <Box sx={{ p: 4, display: 'flex', flexDirection: 'column', gap: 2, maxWidth: 420 }}>
                    <Typography sx={{
                        background: 'linear-gradient(180deg,#fff -31.86%,#a8a6af 132.28%)',
                        WebkitBackgroundClip: 'text',
                        WebkitTextFillColor: 'transparent',
                        fontWeight: 'bold',
                        fontSize: 48,
                        fontFamily: 'PoetsenOne',
                        lineHeight: 1.1,
                    }}>
                        Límite de Tipeos
                    </Typography>

                    <Typography sx={{ color: 'rgba(255,255,255,0.65)', fontSize: 14, mb: 1 }}>
                        Definí cuántas solicitudes de tipeo se pueden realizar. Cuando se agoten, el botón de reclamar queda deshabilitado para todos.
                    </Typography>

                    {estado && (
                        <Box sx={{
                            p: 2.5,
                            borderRadius: 2,
                            border: '1px solid rgba(255,255,255,0.12)',
                            background: 'rgba(255,255,255,0.04)',
                            display: 'flex',
                            flexDirection: 'column',
                            gap: 1,
                        }}>
                            <Typography sx={{ color: '#fff', fontWeight: 700, fontSize: 14 }}>
                                Estado actual
                            </Typography>
                            <Typography sx={{ color: estado.activo ? '#fbbf24' : '#4ade80', fontSize: 13 }}>
                                {estado.activo ? 'Límite activo' : 'Sin límite (ilimitado)'}
                            </Typography>
                            {estado.activo && (
                                <>
                                    <Typography sx={{ color: '#fff', fontSize: 28, fontWeight: 800, fontFamily: 'PoetsenOne' }}>
                                        {estado.disponibles}
                                        <Typography component="span" sx={{ color: 'rgba(255,255,255,0.5)', fontSize: 14, ml: 1, fontWeight: 400 }}>
                                            restantes de {estado.limite}
                                        </Typography>
                                    </Typography>
                                    <Typography sx={{ color: 'rgba(255,255,255,0.45)', fontSize: 12 }}>
                                        Usados: {estado.usados}
                                    </Typography>
                                </>
                            )}
                        </Box>
                    )}

                    <TextField
                        type="number"
                        label="Cantidad de solicitudes permitidas"
                        value={cantidad}
                        onChange={(e) => setCantidad(e.target.value)}
                        fullWidth
                        inputProps={{ min: 0 }}
                        InputLabelProps={{ style: { color: '#fff' } }}
                        InputProps={{ style: { color: '#fff' } }}
                        sx={{
                            '& .MuiOutlinedInput-root': {
                                '& fieldset': { borderColor: '#fff' },
                                '&:hover fieldset': { borderColor: '#ccc' },
                            },
                        }}
                        helperText="Ej: 3 → solo se podrán hacer 3 solicitudes de tipeo"
                        FormHelperTextProps={{ sx: { color: 'rgba(255,255,255,0.45)' } }}
                    />

                    <Button
                        variant="contained"
                        color="primary"
                        disabled={!cantValida || loading}
                        onClick={() => abrirConfirmacion('set')}
                    >
                        ACTIVAR / ACTUALIZAR LÍMITE
                    </Button>

                    <Button
                        variant="outlined"
                        disabled={loading || !estado?.activo}
                        onClick={() => abrirConfirmacion('off')}
                        sx={{
                            color: '#fff',
                            borderColor: 'rgba(255,255,255,0.35)',
                            '&:hover': { borderColor: '#fff' },
                        }}
                    >
                        DESACTIVAR LÍMITE
                    </Button>

                    {mensaje && (
                        <Typography color={mensaje.startsWith('Error') ? 'error.main' : 'success.main'}>
                            {mensaje}
                        </Typography>
                    )}

                    <Modal open={modalAbierto} onClose={() => { setModalAbierto(false); setClave(''); }}>
                        <Box sx={modalStyle}>
                            <Typography variant="h6" gutterBottom>
                                Confirmar
                            </Typography>
                            <Typography>
                                {accion === 'off'
                                    ? 'Vas a desactivar el límite. Las solicitudes quedarán ilimitadas.'
                                    : <>Vas a permitir <strong>{cantidad}</strong> solicitudes de tipeo.</>}
                            </Typography>

                            <TextField
                                type="password"
                                label="Contraseña"
                                value={clave}
                                onChange={(e) => setClave(e.target.value)}
                                fullWidth
                                sx={{ mt: 2 }}
                                autoFocus
                            />

                            <Box sx={{ mt: 3, display: 'flex', justifyContent: 'flex-end', gap: 2 }}>
                                <Button onClick={() => { setModalAbierto(false); setClave(''); }}>Cancelar</Button>
                                <Button variant="contained" disabled={!clave || loading} onClick={handleConfirmar}>
                                    Confirmar
                                </Button>
                            </Box>
                        </Box>
                    </Modal>
                </Box>
            </Box>
        </Nlayout>
    );
}

export default LimiteTipeos;
